import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ApplicationTruncatePipe} from '../application-truncate.pipe';
import {RoundPipe} from '../application-truncate.pipe';
import { searchFilterPipe } from '../searchFilter.pipe';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [ApplicationTruncatePipe,RoundPipe, searchFilterPipe],
  exports: [ApplicationTruncatePipe,RoundPipe, searchFilterPipe]
})
export class SharedModule {
}
